import { toast } from "react-toastify";

export const errorMsg = (message) => {
  toast.error(message, { toastId: message });
};

export const successMsg = (message) => {
  toast.success(message, { toastId: message });
};
